import { atom } from 'recoil'
import { IDashboardGroup } from '@/pages/Dashboards/dashboards.types.ts'

interface IDashboardGroupsState {
  items: IDashboardGroup[]
}
const dashboardGroupsAtom = atom<IDashboardGroupsState>({ key: '/dashboards/groups', default: { items: [] } })

export default dashboardGroupsAtom
